<div class="flex flex--middle flex--nowrap ps-xsmall-y font-body-medium">
  <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.AM_LOGO" />
  <div class="ps-small-l" [innerHTML]="'aurinkomatkat.inCooperation' | finLocalization"></div>
</div>

@if (showCompact$ | async) {
  <div class="selector-grid compact grid-col-12 no-gutters" data-testid="widget-selector-grid">
    <div class="col-1-12">
      <fin-location-selector
        [locationPair]="locations$ | async"
        [showPreviousSearches]="false"
        [isAm]="true"
        [amOrigins]="amOrigins$ | async"
        [amDestinations]="destinations$ | async"
        [showSeparator]="false"
        (setLocations)="updateLocations($event)"
      />
    </div>
  </div>
}

@if ((showCompact$ | async) === false) {
  <div class="selector-grid grid-col-12 no-gutters" data-testid="widget-selector-grid">
    <div class="col-1-12">
      <fin-location-selector
        [locationPair]="locations$ | async"
        [showPreviousSearches]="false"
        [isAm]="true"
        [amOrigins]="amOrigins$ | async"
        [amDestinations]="destinations$ | async"
        [showSeparator]="false"
        (setLocations)="updateLocations($event)"
      />
    </div>

    <div class="md-col-1-4 col-1-12">
      <fin-am-room-selector (setRooms)="updateRooms($event)" />
    </div>

    <div class="md-col-5-12 col-1-12">
      <fin-am-dates-selector
        [travelDates]="travelDates$ | async"
        [amDestination]="selectedAmDestination$ | async"
        [amAvailability]="availability$ | async"
        (setTravelDates)="setTravelDates($event)"
        (setDuration)="setDuration($event)"
      />
    </div>

    <div class="col-1-12">
      <div class="flex flex--end flex--middle ps-medium-t" data-testid="booking-widget-footer">
        <fcom-button
          class="continue-btn"
          [theme]="ButtonTheme.PRIMARY_ACCENT"
          [size]="ButtonSize.LARGE"
          [mode]="ButtonMode.FILL"
          [loading]="false"
          [text]="'bookingSearch.search' | finLocalization"
          [disabled]="(selectionIsValid$ | async) === false"
          (clickBtn)="openContinueModal()"
          data-testid="booking-widget-search-button"
        />
      </div>
      <fin-booking-widget-notifications [isAm]="true" />
    </div>
  </div>

  @if (selectedAmDestination$ | async; as destination) {
    <fcom-modal
      [(open)]="continueModalOpen"
      [title]="
        'aurinkomatkat.continueModal.title' | finLocalization: { holidayType: destination.holidayTypeItem.label }
      "
      [fitToContent]="true"
      [buttons]="ModalButtons.CONTINUE_CANCEL"
      (confirm)="continueToAm()"
      data-testid="am-continue-modal"
    >
      <div class="pr-large">
        <div class="flex flex--middle ps-small-b">
          <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.AM_LOGO" />
          <div class="nordic-blue-900-text text-icon-primary mr-xsmall-l font-headline-small">
            {{ 'aurinkomatkat.continueModal.contentTitle' | finLocalization }}
          </div>
        </div>
        <div class="font-body-medium">
          {{ 'aurinkomatkat.continueModal.content' | finLocalization }}
        </div>
      </div>
    </fcom-modal>
  }
}
